import { render, staticRenderFns } from "./JfList.vue?vue&type=template&id=fe0d6cfc&scoped=true&"
import script from "./JfList.vue?vue&type=script&lang=js&"
export * from "./JfList.vue?vue&type=script&lang=js&"
import style0 from "./JfList.vue?vue&type=style&index=0&id=fe0d6cfc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0d6cfc",
  null
  
)

export default component.exports